<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>出入库单</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-card shadow="hover">
            <!-- 搜索 -->
            <el-form :inline="true" size="small" v-model="listQuery">
                <!-- <el-form-item label="仓库编号">
          <el-input v-model="listQuery.houseId" placeholder="请输入仓库编号" clearable></el-input>
        </el-form-item> -->
         <el-form-item label="出入库订单号">
                    <el-input v-model="listQuery.stockOrderNo" placeholder="请输入出入库订单号" clearable></el-input>
                </el-form-item>
                <el-form-item label="关联业务单号">
                    <el-input v-model="listQuery.relationNo" placeholder="请输入关联业务单号" clearable></el-input>
                </el-form-item>
                <el-form-item label="城市">
                    <el-select v-model="listQuery.cityId" clearable placeholder="请选择城市" filterable @change="cityChange">
                        <el-option v-for="(item,index) in cityList" :key="index" :label="item.cityName" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="仓库">
                    <el-select v-model="listQuery.houseIdList" clearable placeholder="请选择仓库" multiple filterable>
                        <el-option v-for="(item,index) in houseList" :key="index" :label="item.houseName" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="业务类型">
                    <el-select v-model="listQuery.relationType" clearable placeholder="请选择业务类型">
                        <el-option v-for="(item,index) in typeList" :key="index" :label="item.text" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="状态">
                    <el-select v-model="listQuery.status" clearable placeholder="请选择状态">
                        <el-option v-for="(item,index) in statusList" :key="index" :label="item.text" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="日期">
                    <el-date-picker v-model="listQuery.timePart" type="daterange" range-separator="至" value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button icon="el-icon-search" type="primary" plan @click="querySearch">查询</el-button>
                </el-form-item>
            </el-form>

            <!-- 列表数据 -->
            <el-table :data="listData" border style="width: 100%" class="table">
                <el-table-column prop="id" label="ID" width="50px" fixed="left"></el-table-column>

                <el-table-column prop="stockOrderNo" label="出入库订单号" width="120" fixed="left"></el-table-column>
                <el-table-column prop="relationNo" label="关联业务单号"></el-table-column>
                <el-table-column prop="relationType" label="业务类型">
                    <template slot-scope="scope">{{scope.row.relationType | typeFilter}}</template>
                </el-table-column>
                <el-table-column prop="status" label="状态">
                    <template slot-scope="scope">{{scope.row.status | statusFilter}}</template>
                </el-table-column>
                <el-table-column prop="outHouse.id" label="出库仓编号"></el-table-column>
                <el-table-column prop="outHouse.houseName" label="出库仓名称"></el-table-column>
                <el-table-column prop="outHouse.houseAddress" label="出库仓地址"></el-table-column>
                <el-table-column prop="type" label="出库仓类型">
                    <template slot-scope="scope">
                        <span v-if="scope.row.outHouse.type==1">普通仓库</span>
                        <span v-if="scope.row.outHouse.type==2">维修</span>
                        <span v-if="scope.row.outHouse.type==3">报废</span>
                    </template>
                </el-table-column>
                <el-table-column prop="inHouse.id" label="入库仓编号"></el-table-column>
                <el-table-column prop="inHouse.houseName" label="入库仓名称"></el-table-column>
                <el-table-column prop="inHouse.houseAddress" label="入库仓地址"></el-table-column>
                <el-table-column prop="type" label="入库仓类型">
                    <template slot-scope="scope">
                        <span v-if="scope.row.inHouse.type==1">普通仓库</span>
                        <span v-if="scope.row.inHouse.type==2">维修</span>
                        <span v-if="scope.row.inHouse.type==3">报废</span>
                    </template>
                </el-table-column>
                <el-table-column prop="reason" label="原因"></el-table-column>
                <el-table-column prop="remark" label="备注"></el-table-column>
                <el-table-column prop="createTime" label="创建时间" :formatter="dateFormatA" width="140px"></el-table-column>
                <el-table-column prop="updateTime" label="更新时间" :formatter="dateFormatA" width="140px"></el-table-column>

                <el-table-column prop label="操作" fixed="right" width="120px" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" @click="shipmentDetail(scope.row)" size="mini">操作详情</el-button>
                        <el-button type="text" @click="goStockLog(scope.row)" size="mini">出入库记录</el-button>
                        <el-button type="text" @click="handleOrder(4,scope.row.id)" v-if="scope.row.status==1">拒绝</el-button>
                        <el-button type="text" @click="handleOrder(3,scope.row.id)" v-if="scope.row.status==2||scope.row.status==1"  v-per="'finishShipment'">完成处理</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <pagination :total="total" :page.sync="currentPage" :limit.sync="pageSize" @pagination="querySearch" />
        </el-card>
        <!-- 出入库详情 -->

        <el-dialog title="出入库详情" :visible.sync="detailVisable" width="1000px" :close-on-click-modal="false" center>
            <div style="margin:10px;font-size:15px;">
                <el-row>
                    <el-col :span="12">业务类型：{{orderInfo.stockOrder.relationType | typeFilter}}</el-col>
                    <el-col :span="12">状态：{{orderInfo.stockOrder.status | statusFilter}}</el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">入库仓：{{orderInfo.stockOrder.inHouse.houseName}}</el-col>
                    <el-col :span="12">出库仓：{{orderInfo.stockOrder.outHouse.houseName}}</el-col>
                </el-row>

            </div>
            <div class="item-text">
                <span class="item-circle"></span>出入库清单
            </div>
            <el-table :data="orderInfo.stockOrderGoodsList" border style="width: 100%" class="table">
                <!-- <el-table-column prop="id" label="id"></el-table-column> -->

                <el-table-column prop="stockOrderId" label="出入库订单ID"></el-table-column>
                <el-table-column prop="inOrOut" label="出入库类型">
                    <template slot-scope="scope">
                        <span v-if="scope.row.inOrOut==1">入库</span>
                        <span v-if="scope.row.inOrOut==2">出库</span>
                        <span>({{getHouseName(scope.row.houseId)}})</span>
                    </template>
                </el-table-column>
                <el-table-column prop="skuName" label="商品名称"></el-table-column>
                <el-table-column prop="skuCode" label="商品编号"></el-table-column>
                <el-table-column prop="numbers" label="数量"></el-table-column>
                <el-table-column prop="costPrice" label="价格"></el-table-column>
                <el-table-column prop="codeSn" label="sn编码"></el-table-column>
                <!-- <el-table-column prop="houseId" label="仓库id"></el-table-column> -->
            </el-table>

            <div class="item-text">
                <span class="item-circle"></span>操作记录
            </div>
            <el-table :data="orderInfo.stockOrderLog" border style="width: 100%" class="table">
                <el-table-column prop="stockOrderId" label="出入库订单ID"></el-table-column>
                <el-table-column prop="statusName" label="状态"></el-table-column>
                <el-table-column prop="remark" label="备注"></el-table-column>
                <el-table-column prop="operUserName" label="操作人"></el-table-column>
                <el-table-column prop="operTime" :formatter="dateFormatA" label="操作时间"></el-table-column>
            </el-table>

            <!-- <div class="item-text">
          <span class="item-circle"></span>出入库记录
      </div> -->

            <span slot="footer" class="dialog-footer">
                <!-- <el-button @click=" handleOrder(2)" v-if="orderInfo.stockOrder.status==1" type="primary">接收处理</el-button>
                <el-button @click="handleOrder(3)" v-if="orderInfo.stockOrder.status==2" type="primary">完成处理</el-button> -->
                <!-- <el-button @click=" handleOrder(4)" type="danger" v-if="orderInfo.stockOrder.status==1||orderInfo.stockOrder.status==2">拒绝</el-button> -->
            </span>
        </el-dialog>

        <el-dialog :title="handleTitle" :visible.sync="handleVisible" width="600px" :close-on-click-modal="false" center>
            <el-form label-width="100px" :model="handleForm" ref="handleForm" :rules="handleRules" size="medium">
                <el-form-item label="备注" prop="mark">
                    <el-input type="textarea" style="width:400px" :rows="3" placeholder="请输入备注" v-model="handleForm.remark"></el-input>
                </el-form-item>
                <el-form-item label="拒绝原因" prop="reason" v-if="handleForm.state=='4'">
                    <el-input type="textarea" style="width:400px" :rows="3" placeholder="请输入拒绝原因" v-model="handleForm.reason"></el-input>
                </el-form-item>
            </el-form>
            <el-row v-if="errmsg!=''">
                <div v-html="errmsg" style="color:red;"></div>
            </el-row>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleVisible = false">取消</el-button>
                <el-button type="primary" @click="confHandle()">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import moment from "moment";
import Pagination from "../common/Pagination";
import wmsApi from "@/script/api/wmsApi";
import globalData from "@/components/common/globaldata/global.data.vue";
import "./css/index.css";
let vm;
export default {
    components: { Pagination },
    filters: {
        typeFilter(value) {
            const rs = vm.typeList.filter((item) => {
                return item.id === value;
            });

            if (rs != null && rs.length > 0) {
                return rs[0].text;
            }
        },
        statusFilter(value) {
            const rs = vm.statusList.filter((item) => {
                return item.id === value;
            });

            if (rs != null && rs.length > 0) {
                return rs[0].text;
            }
        },
    },
    data() {
        return {
            orderInfoId:'',
            errmsg: "",
            typeList: [
                {
                    id: 1,
                    text: "采购单入库单",
                },
                {
                    id: 2,
                    text: "销售单",
                },
                {
                    id: 3,
                    text: "转仓单",
                },
                {
                    id: 4,
                    text: "盘库单",
                },
                {
                    id: 5,
                    text: "租赁归还单",
                },
            ],
            statusList: [
                {
                    id: 1,
                    text: "待处理",
                },
                {
                    id: 2,
                    text: "处理中",
                },
                {
                    id: 3,
                    text: "已完成",
                },
                {
                    id: 4,
                    text: "取消拒绝",
                },
            ],
            listData: [],
            total: 0,
            pageSize: 10,
            currentPage: 1, //当前页
            cityList:[],
            houseList:[],
            tempHouseList:[],
            listQuery: {
                cityId: "",
                houseIdList: [],
                stockOrderNo: "",
                relationNo: "",
                relationType: "",
                status: "",
                timePart: [],
            },
            detailVisable: false,
            orderInfo: {
                stockOrder: {
                    inHouse: {},
                    outHouse: {},
                },
                stockOrderGoodsList: [],
                houseStockLog: [],
                stockOrderLog: [],
            },
            handleTitle: "",
            handleVisible: false,
            handleForm: {
                reason: "",
                remark: "",
                state: "",
            },
            handleRules: {
                reason: [
                    {
                        required: true,
                        message: "请输入拒绝原因",
                        trigger: "change",
                    },
                ],
            },
            pickerOptions: {
                shortcuts: [
                    {
                        text: "最近一周",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 7
                            );
                            picker.$emit("pick", [start, end]);
                        },
                    },
                    {
                        text: "最近半个月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 15
                            );
                            picker.$emit("pick", [start, end]);
                        },
                    },
                    {
                        text: "最近一月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 30
                            );
                            picker.$emit("pick", [start, end]);
                        },
                    },
                ],
            },
        };
    },
    beforeCreate() {
        vm = this;
    },
    created() {
        // this.querySearch();
        this.getAllCity();
        this.getAllHouse();
    },
    activated(){
        this.listQuery.relationNo=this.$route.query.orderNo;
        this.listQuery.relationType=this.$route.query.relationType;
        this.querySearch();
    },
    methods: {
       getAllCity() {
            //城市下拉框
            wmsApi.$axiosgetallCity().then((res) => {
                if (res.data.errno == 0) {
                    this.cityList = res.data.data;
                }
            });
        },
        getHouseName(houseId){
            let houseName="";
             this.houseList.forEach(e=>{
                 if(e.id==houseId){
                     houseName=e.houseName;
                 }
             })
             return houseName;
        },
        getAllHouse() {
            //仓库下拉框
            wmsApi
                .$axiosgetAllHouse({ sysUserId: globalData.userInfo.id })
                .then((res) => {
                    if (res.data.errno == 0) {
                        this.houseList = res.data.data;
                          this.tempHouseList = res.data.data;
                        if (this.houseList.length > 0) {
                            let arr = [];
                            this.houseList.forEach((e) => {
                                if (e.mark) {
                                    arr.push(e.id);
                                }
                            });
                            console.log(arr);
                            this.listQuery.houseIdList = arr;
                            this.querySearch();
                        }
                    }
                });
        },
        cityChange(cityId) {
            this.listQuery.houseIdList = [];
            let temparr = [];
            this.tempHouseList.filter((item) => {
                if (item.cityId == cityId) {
                    temparr.push(item);
                }
            });
            this.houseList = temparr;
        },
        goStockLog(row) {
            this.$router.push({
                path: "/warehouseCenter/warehouseManage/stocklogList",
                query: {
                    relationNo: row.relationNo,
                },
            });
        },
        //查询
        querySearch() {
            let temp = {
                pageNum: this.currentPage,
                pageSize: this.pageSize,
                houseId: this.listQuery.houseId,
                stockOrderNo: this.listQuery.stockOrderNo,
                relationNo: this.listQuery.relationNo,
                relationType: this.listQuery.relationType,
                status: this.listQuery.status,
                houseIdList:this.listQuery.houseIdList
            };
            if (
                this.listQuery.timePart != "" &&
                this.listQuery.timePart != undefined
            ) {
                temp.startDate = this.listQuery.timePart[0] + " 00:00:00";
                temp.endDate = this.listQuery.timePart[1] + " 23:59:59";
            }

            wmsApi
                .$axiosGetStockOrderList(temp)
                .then((res) => {
                    this.listData = res.data.data.list;
                    this.total = res.data.data.total;
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        shipmentDetail(row) {
            wmsApi
                .$axiosGetStockOrderInfo({
                    stockOrderId: row.id,
                })
                .then((res) => {
                    this.detailVisable = true;
                    this.orderInfo = res.data.data;
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        handleOrder(state,id) {
            this.orderInfoId=id;
            this.errmsg = "";
            this.handleForm = {
                state: state,
                reason: "",
                remark: "",
            };
            this.handleVisible = true;
            this.handleTitle =
                state == 2 ? "接收处理" : state == 3 ? "处理完成" : "拒绝";
        },
        confHandle() {
            this.$refs["handleForm"].validate((valid) => {
                if (valid) {
                    let params = {
                        // stockOrderId: this.orderInfo.stockOrder.id,
                        stockOrderId: this.orderInfoId,
                        reason: this.handleForm.reason,
                        remark: this.handleForm.remark,
                        state: this.handleForm.state,
                        operUserId: globalData.userInfo.id,
                        operUserName: globalData.userInfo.userName,
                    };
                    wmsApi
                        .$axiosOperateStockOrder(params)
                        .then((res) => {
                            if (res.data.errno == 0) {
                                this.$message.success("提交成功");
                                this.handleVisible = false;
                                this.querySearch();
                                // this.shipmentDetail({
                                //     id: this.orderInfo.stockOrder.id,
                                // });
                            } else {
                                this.$message.error(res.data.data);
                            }
                        })
                        .catch((err) => {
                            console.log(err.data);
                            this.errmsg = err.data.errmsg;
                        });
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
    },
};
</script>
<style scoped>
.crumbs {
    margin: 0 0 10px 0;
}
.btn-margin .el-button--small {
    margin: 10px 12px 0 0;
}
>>> .el-image img {
    height: 60px;
    width: 60px;
    margin: 0 12px 12px 0;
    object-fit: cover;
}
.item-text {
    padding-left: 10px;
    font-weight: 700;
    color: #636363;
    margin: 10px 0px;
}
.item-circle {
    height: 12px;
    width: 4px;
    display: inline-block;
    background: #0686d8;
    margin-right: 5px;
}
</style>
